import { useQuery } from "@tanstack/react-query";
import { getJobEvents } from "../../../jobs/jobs-list/jobs-layout/actions/getJobEvents";

export interface JobEventsResponse {
  items: any[];
  totalItems: number;
  currentEventIndex: number;
}

export function useJobEventsByIdQuery(jobId: number) {

  const query = useQuery<JobEventsResponse, Error, JobEventsResponse>({
    queryKey: ["job-events-no-pagination", jobId],
    queryFn: async () => {
      return await getJobEvents({
        jobId,
        page: 1,
        pageSize: 10000,
        order: "ASC",
      }) as JobEventsResponse;
    },
    enabled: Boolean(jobId),
    staleTime: 1000 * 30,
  });

  return {
    ...query,
    events: query.data?.items ?? [],
    totalItems: query.data?.totalItems ?? 0,
    currentEventIndex: query.data?.currentEventIndex ?? -1,
  };
}
